import { html, LitElement } from 'lit-element';
import '@giswebgroup/ki-wcp-base/src/components/ki-icon/ki-icon';
import '@giswebgroup/ki-wcp-base/src/components/ki-checkbox/ki-checkbox';

import responsive, { SM, ViewPort } from '@giswebgroup/ki-wcp-base/src/decorators/responsive';
import i18n from '@giswebgroup/ki-wcp-base/src/decorators/i18n';
import nls from '../../locales/index.nls';
import style from './ki-layers-control-element.css';

// TODO rework to read from map.
function toggleValue(array, value, flag, conflictList) {
  const i = array.indexOf(value);
  if (conflictList) {
    conflictList.forEach(v => {
      array.indexOf(v) >= 0 && array.splice(array.indexOf(v), 1);
    });
  }
  if (flag) {
    array.push(value);
  } else if (i >= 0) {
    array.splice(array.indexOf(value), 1);
  }
}

export default
@responsive
@i18n(nls)
class KiLayersControlElement extends LitElement {
  // language=CSS
  // static styles = style;

  constructor() {
    super();
    this.values = [];
    this.layers = [];
    this.__maxHeight = null;

    // fix for bug fire map dragging
    const stopEvent = e => {
      e.stopPropagation();
    };
    this.onpointerdown = stopEvent;
    this.onpointerup = stopEvent;
  }

  static get properties() {
    return {
      layers: {
        type: Array,
      },
      values: {
        type: Object,
      },
    };
  }

  _renderCheckBoxGroup(group) {
    return html`
      <div class="field-group">
        <div class="title">${this.i18n.t(group.label)}</div>
        ${group.options.map(
          option => html`
            <div class="layer-item">
              <ki-checkbox
                @change="${e => {
                  toggleValue(this.values, option.value, e.target.checked);
                  this._emitChange();
                }}"
                ?checked="${this.values.indexOf(option.value) >= 0}"
              ></ki-checkbox>
              <div class="label">${option.label} ${option.legendColor ? html`<span class="colorlegend" style="background-color:${option.legendColor};"></span>` : ''}</div>
            </div>
          `,
        )}
      </div>
    `;
  }

  _renderRadioGroup(group) {
    return html`
      <div class="field-group">
        <div class="title">${this.i18n.t(group.label)}</div>
        ${group.options.map(
          option => html`
            <div class="layer-item radio">
              <input type="radio" 
                class="radiobutton"
                @change="${e => {
                  toggleValue(
                    this.values,
                    option.value,
                    e.target.checked,
                    group.options.map(op => op.value),
                  );
                  this.renderRoot.querySelectorAll('.radiobutton').forEach(node => {
                      node.checked = node === e.target
                  })
                  this._emitChange();
                }}"
                ?checked="${this.values.indexOf(option.value) >= 0}"
              />
              <div class="label">${option.label}</div>
            </div>
          `,
        )}
      </div>
    `;
  }

  _emitChange() {
    this.requestUpdate();
    this.dispatchEvent(
      new CustomEvent('changed', {
        detail: {
          values: this.values,
        },
      }),
    );
  }

  _renderLayerList() {
    return html`
      <div class="layer-list">
        ${this.layers.map((group, index) => {
          if (group.type === 'checkbox') {
            return [this._renderCheckBoxGroup(group), index === this.layers.length - 1 ? '' : html` <hr /> `];
          }
          if (group.type === 'radio') {
            return [this._renderRadioGroup(group), index === this.layers.length - 1 ? '' : html` <hr /> `];
          }
          return '';
        })}
      </div>
    `;
  }

  render() {
    let list;
    if (ViewPort.size === SM) {
      list = html`
        <ki-modal
          id="layers-options"
          label="${this.i18n.t("Layer_selection")}"
          @click="${() => {
            this._removeVisible();
          }}"
          closeable
          >${this._renderLayerList()}</ki-modal
        >
      `;
    } else {
      list = this._renderLayerList();
    }
    // language=html
    return html`
      ${style}
      <ki-icon-btn id="layers-control-btn" class="toggle-btn" icon="ki ki-layers" @click="${this._toggleList}" alt="Map layers"></ki-icon-btn>
      <paper-tooltip position="left" for="layers-control-btn" role="tooltip" aria-describedby="layers-control-btn">${this.i18n.t('Layer_selection')}</paper-tooltip>
      ${list}
    `;
  }
  
  createRenderRoot() {
  /**
   * Render template without shadow DOM. Note that shadow DOM features like
   * encapsulated CSS and slots are unavailable.
   */
    return this;
  }

  _removeVisible() {
    const layerOptions = this.renderRoot.querySelector('#layers-options');
    if (layerOptions && !layerOptions.visible) {
      this.classList.remove('list-visible');
    }
  }

  _toggleList() {
    if (ViewPort.size === SM) {
      this.classList.toggle('list-visible');
      this.renderRoot.querySelector('#layers-options').show();
    } else {
      this.classList.toggle('list-visible');
    }
  }
}

customElements.define('ki-layers-control-element', KiLayersControlElement);